import DataContainer from 'Components/UI/DataContainer';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import GoalStrategiesDetailsMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/GoalStrategiesDetailsMetaOverride';
import {
  GoalStrategyDetailsSkeleton,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Sections/GoalStrategyDetailsSkeleton';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useGoalStrategiesDetailsContext } from './GoalStrategiesDetailsContext';
import { GoalStrategiesDetailsLayout } from './GoalStrategiesDetailsLayout';

const useStyles = buildUseStyles('GoalStrategiesDetailsContainer', () => ({
  root: {
    width: '100%',
  },
}));

export const GoalStrategiesDetailsContainer = ({ relationship }) => {
  const {
    collection: goalsCollection,
    fetchGoalDetails,
    loading,
    currentGoalIdx,
  } = useGoalStrategiesDetailsContext();
  const theme = useTheme();
  const classes = useStyles(theme);

  const currentResource = goalsCollection?.resources().index(currentGoalIdx);
  const totalGoals = goalsCollection?.resources().length();
  const numGoalsCompleted = currentGoalIdx + 1;

  useEffect(() => {
    fetchGoalDetails(relationship);
  }, [relationship]);

  return (
    <DataContainer
      className={classes.root}
      component={MetaResourceRenderer}
      componentProps={{
        LayoutProps: {
          totalGoals,
          numGoalsCompleted,
          showGoalStepper: true,
        },
        metaOverrideSet: GoalStrategiesDetailsMetaOverride,
        layout: GoalStrategiesDetailsLayout,
        resource: currentResource,
      }}
      loading={loading || !currentResource}
      skeleton={GoalStrategyDetailsSkeleton}
    />
  );
};

GoalStrategiesDetailsContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
